module.exports = __webpack_public_path__ + "media/images/flavours/icon-mur_dark-d38c325bb34109061460d04c4ed9900a.png";